// extracted by mini-css-extract-plugin
export var ourTeam = "ourTeam-module--our-team--ab9b4";
export var ourTeamPerson = "ourTeam-module--our-team-person--8d9e3";
export var ourTeamWrapper = "ourTeam-module--our-team-wrapper--83bf2";